import React, { useContext } from 'react';
import { func } from 'prop-types';
import { Box, Typography, useMediaQuery } from '@mui/material';

import { DrawerContext } from 'common/drawer/DrawerContext';

// Components
import { DRAWER_TYPES } from 'utils/constants';
import { SEARCH_STATUS } from '../../../utils';
import MobileMenuItems from '../../mobile-menu-items/MobileMenuItems.connector';
import DesktopButtons from '../../desktop-buttons/DesktopButtons.connector';
import CreatePtoWizard from '../../../create-wizard/CreateWizard.connector';

const SwimlaneTopBar = ({ resetCreatePto, resetFilters, updateSearchPtoFilter }) => {
  const { setDrawerComponentProps } = useContext(DrawerContext);
  const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'));

  const handleClickViewList = () => {
    resetFilters();
    updateSearchPtoFilter('status', SEARCH_STATUS.all, false);
  };

  const handleClickViewClosed = () => {
    resetFilters();
    updateSearchPtoFilter('status', SEARCH_STATUS.allClosed, false);
  };

  const handleCreateNew = () =>
    setDrawerComponentProps({
      Component: props => <CreatePtoWizard isCopyToNew={false} {...props} />,
      resetWizard: resetCreatePto,
      type: DRAWER_TYPES.createNewPto,
    });

  return lgUp ? (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'surface.light',
        display: 'flex',
        justifyContent: 'space-between',
        padding: 3,
        position: 'fixed',
        top: 48,
        whiteSpace: 'nowrap',
        width: '100%',
        zIndex: 3,
      }}
    >
      <Typography sx={{ color: 'primary.dark' }} variant="h5">
        Open Product Transfer Orders
      </Typography>
      <Box>
        <DesktopButtons
          handleClickViewClosed={handleClickViewClosed}
          handleClickViewList={handleClickViewList}
          onCreateNew={handleCreateNew}
        />
      </Box>
    </Box>
  ) : (
    <MobileMenuItems
      handleClickViewClosed={handleClickViewClosed}
      handleClickViewList={handleClickViewList}
      onCreateNew={handleCreateNew}
    />
  );
};

SwimlaneTopBar.propTypes = {
  resetCreatePto: func.isRequired,
  resetFilters: func.isRequired,
  updateSearchPtoFilter: func.isRequired,
};

export default SwimlaneTopBar;
